import { useEffect, useState } from "react";

/* THE SORT LIVES IN THE URL, AND THE URL IS THE ONE THAT WINS.
 *
 * 🔴 THE BUG THIS EXISTS FOR WAS DRIVEN, NOT IMAGINED (2026-09-18). The library table read the
 * sort out of the hash in a `useState` INITIALISER — which runs once, when the component mounts.
 * These screens do not remount on navigation: they are the backdrop the editor's window opens
 * over, and the SPA keeps them alive. So a coach with the app already open, pasting
 * `#/exercises?sort=records&dir=asc` from a colleague, kept whatever sort THEY had last clicked.
 * MEASURED: the hash parsed correctly to `{sort: "records", dir: "asc"}` while the table sat on
 * `Last used, ascending`. The link looked like it worked — the address bar was right and the page
 * was on the right screen — and the one thing the link was FOR was silently ignored.
 *
 * ⚠️ WHICH MAKES "THE SORT IS IN THE URL" A CLAIM THAT NEEDED DRIVING RATHER THAN READING. The
 * code plainly contained `sortFromQuery(routeQuery(...))`; what it did not contain was a reason
 * for that line to run a second time.
 *
 * ⚠️ `replaceState` DOES NOT FIRE `hashchange`, which is why writing the sort back to the URL from
 * a header click cannot loop through this listener.
 */
/* ⚠️ `S` IS UNCONSTRAINED because the roster's sort is `{key, dir} | null` — `null` there is
   "the screen's own default order", a real state and not an absence of one. A constraint of
   `S extends {key, dir}` would have forced the roster to invent a sort it does not have. */
export function useQuerySort<S>(
  read: (q: Record<string, string>) => S,
  query: (hash: string) => Record<string, string>,
): [S, (next: S) => void] {
  const [sort, setSort] = useState<S>(() => read(query(window.location.hash)));
  useEffect(() => {
    const onHash = () => setSort(read(query(window.location.hash)));
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
    // `read` and `query` are module-level functions at every call site; listing them would
    // re-subscribe on each render for no benefit.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return [sort, setSort];
}
